import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-page-downloads-mss',
  templateUrl: './page-downloads-mss.component.html',
  styleUrls: ['./page-downloads-mss.component.css']
})
export class PageDownloadsMssComponent implements OnInit {
    pageName = 'downloads_mss';
    downloadBaseUrl: string;
    authToken: string;

    ngOnInit(): void {
        this.downloadBaseUrl = environment.endpoints.res + '/downloads';
        this.authToken = environment.apiKey;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/pages/page-downloads-mss/page-downloads-mss.component.ts